import React, { FC } from 'react';

const TaxonomyIcon: FC<Record<string, never>> = () => (
  <span className={'icon-taxonomy'} />
);

export default TaxonomyIcon;
